import Checkbox from './checkbox'
import CheckboxGroup from './checkboxGroup'
Checkbox.CheckboxGroup = CheckboxGroup;
export default Checkbox;
